import { render } from "./Selector.vue?vue&type=template&id=a0d44afa&ts=true"
import script from "./Selector.vue?vue&type=script&lang=ts"
export * from "./Selector.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__